import { withComponentLabel } from '../../utils/debug'

const CategoryListPage = ({model, headerString, ...props}) => {
  return (
    <>
      {model && (
        <>
          {/* TODO pull out to a header component */}
          <div className='h-5 -mt-1 -mx-0.5 z-10 border-t-gray-200 border-x-2 rounded-t-2xl bg-emerald-400'></div>
          <div className='bg-emerald-400 rounded-b-full border-gray-300 shadow-lg shadow-emerald-100 pb-4'>
            <div className='flex items-center justify-center'>
              <div className='flex-grow text-center text-white font-extrabold text-3xl tracking-widest'>
                {headerString}
              </div>
            </div>
          </div>
          {props.children}
        </>
      )}
    </>
  )
}

export default withComponentLabel(
  CategoryListPage,
  'CategoryListPage'
)
